module.exports = __webpack_public_path__ + "static/media/NGA.e7b6d906.svg";